module.exports = __webpack_public_path__ + "img/sk_green_large.cc2b392a.jpg";